import { createSvgIcon } from '@mui/material/utils'

const GettingStarted = createSvgIcon(
  <g fill="none">
    <path
      d="M80.4995 96.5675V17.1399C84.1298 17.7016 86.5956 22.7702 86.5956 28.3595V65.1691H80.4995"
      stroke="#204ECF"
      strokeWidth="1.36991"
      strokeLinejoin="round"
    />
    <path
      d="M66.8552 19.8521L65.9921 42.8255L60.3755 48.1271L60.9097 95.9097H53.5807"
      stroke="#204ECF"
      strokeWidth="1.36991"
      strokeLinejoin="round"
    />
    <path
      d="M48.2378 19.8523L49.1008 42.8258L54.7175 48.1273L53.5805 95.9099"
      stroke="#204ECF"
      strokeWidth="1.36991"
      strokeLinejoin="round"
    />
    <path
      d="M60.3752 19.8523V38.5105"
      stroke="#204ECF"
      strokeWidth="1.36991"
      strokeLinejoin="round"
    />
    <path
      d="M54.7179 19.8523V38.5105"
      stroke="#204ECF"
      strokeWidth="1.36991"
      strokeLinejoin="round"
    />
  </g>,
  'GettingStarted'
)

export default GettingStarted
